export default "__VITE_ASSET__BP9U8HC7__"